import { render, staticRenderFns } from "./ProductAttributePrice.vue?vue&type=template&id=3c1cb0a6&"
import script from "./ProductAttributePrice.vue?vue&type=script&lang=js&"
export * from "./ProductAttributePrice.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributePrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports